import * as $ from "jquery";
import * as url from "CMS/core/url";
import { IWidgetInitializeOptions } from "CMS/core/Widget";

export default class MobileMenuPart {
    private options: IWidgetInitializeOptions;
    private $root: JQuery<HTMLElement>;

    // eslint-disable-next-line
    public initialize(options: any) {
        this.options = options;
        this.$root = $(options.root);

        $(options.root).find('ul.language-list > li').on('click', (e) => {
            const $listItem = $(e.currentTarget);
            this.changeLanguage($listItem.data("code"));
        });
    }
    private changeLanguage(code: string) {
        if (code !== this.options.lang.code) {
            const currentUrl = window.location.href;
            const newUrl = url.updateUrlParameter(currentUrl, 'KL', code);
            window.location.href = newUrl;
        }
    }
}